import React, { FC } from 'react';

import logo from '@assets/images/verticalWhiteHelm.png';
import { UserType } from '@pages/dashboard/SignUp/SignUp';
import { NavLink } from 'react-router-dom';

interface ProfileLogoHeaderProps {
  type?: UserType;
}

const ProfileLogoHeader: FC<ProfileLogoHeaderProps> = ({ type }) => {
  return (
    <header className="flex h-18 py-2 pl-5 w-full border-0 border-b-2 border-solid border-cyan">
      <NavLink to={'/'} className="ml-6">
        <img src={logo} alt="YourCentinel logo" className="h-16" />
      </NavLink>
    </header>
  );
};

export default ProfileLogoHeader;
